import React from 'react';
import './SearchFilters.css';

const DIFICULTAD  = ['fácil', 'media', 'difícil'];
const TIEMPO      = [
  { label: '< 15 min',   min: 0,   max: 15  },
  { label: '15–30 min',  min: 15,  max: 30  },
  { label: '30–60 min',  min: 30,  max: 60  },
  { label: '> 60 min',   min: 60,  max: 9999},
];
const COCINA = [
  'Española','Italiana','Mexicana','Francesa','Japonesa',
  'China','India','Americana','Griega','Árabe','Peruana',
  'Tailandesa','Mediterránea','Vegetariana','Vegana',
];
const FUENTE = [
  { label: '👤 Recetas de usuarios', value: 'usuario'  },
  { label: '🌐 Recetas externas',    value: 'externa'  },
];

const SearchFilters = ({ filters, onChange, onClose, onReset, activeCount }) => {

  const toggle = (key, value) => {
    const current = filters[key] || [];
    const next = current.includes(value)
      ? current.filter(v => v !== value)
      : [...current, value];
    onChange({ ...filters, [key]: next });
  };

  const toggleTiempo = (item) => {
    const current = filters.tiempo || [];
    const exists = current.find(t => t.label === item.label);
    const next = exists
      ? current.filter(t => t.label !== item.label)
      : [...current, item];
    onChange({ ...filters, tiempo: next });
  };

  return (
    <div className="sf-overlay" onClick={onClose}>
      <div className="sf-modal" onClick={e => e.stopPropagation()}>

        <div className="sf-header">
          <span className="sf-title">Filtros</span>
          {activeCount > 0 && (
            <button className="sf-reset" onClick={onReset}>
              Limpiar ({activeCount})
            </button>
          )}
          <button className="sf-close" onClick={onClose}>✕</button>
        </div>

        {/* Dificultad */}
        <div className="sf-section">
          <p className="sf-section-title">Dificultad</p>
          <div className="sf-chips">
            {DIFICULTAD.map(d => (
              <button
                key={d}
                className={`sf-chip${(filters.dificultad || []).includes(d) ? ' active' : ''}`}
                onClick={() => toggle('dificultad', d)}
              >
                {d.charAt(0).toUpperCase() + d.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Tiempo */}
        <div className="sf-section">
          <p className="sf-section-title">Tiempo estimado</p>
          <div className="sf-chips">
            {TIEMPO.map(t => (
              <button
                key={t.label}
                className={`sf-chip${(filters.tiempo || []).find(x => x.label === t.label) ? ' active' : ''}`}
                onClick={() => toggleTiempo(t)}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tipo de cocina */}
        <div className="sf-section">
          <p className="sf-section-title">Tipo de cocina</p>
          <div className="sf-chips sf-chips-wrap">
            {COCINA.map(c => (
              <button
                key={c}
                className={`sf-chip${(filters.cocina || []).includes(c) ? ' active' : ''}`}
                onClick={() => toggle('cocina', c)}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        {/* Fuente */}
        <div className="sf-section">
          <p className="sf-section-title">Fuente</p>
          <div className="sf-chips">
            {FUENTE.map(f => (
              <button
                key={f.value}
                className={`sf-chip${(filters.fuente || []).includes(f.value) ? ' active' : ''}`}
                onClick={() => toggle('fuente', f.value)}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <button className="sf-apply" onClick={onClose}>
          Aplicar filtros{activeCount > 0 ? ` (${activeCount})` : ''}
        </button>

      </div>
    </div>
  );
};

export default SearchFilters;